import {
  startOfToday,
  endOfToday,
  startOfWeek,
  startOfMonth,
  subMonths,
  endOfMonth,
  endOfWeek,
  subWeeks,
} from 'date-fns'

import type { DateRange } from '@/utils/date'

import type { DateFilterOption } from './'

const startWeekOnMondayConfig = { weekStartsOn: 1 } as const

export const getFilterDateRange = (option: DateFilterOption): DateRange => {
  switch (option) {
    case 'today':
      return {
        startDate: startOfToday(),
        endDate: endOfToday(),
      }

    case 'this-week':
      return {
        startDate: startOfWeek(new Date(), startWeekOnMondayConfig),
        endDate: endOfWeek(new Date(), startWeekOnMondayConfig),
      }

    case 'last-week':
      return {
        startDate: startOfWeek(subWeeks(new Date(), 1), startWeekOnMondayConfig),
        endDate: endOfWeek(subWeeks(new Date(), 1), startWeekOnMondayConfig),
      }

    case 'this-month':
      return {
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date()),
      }

    case 'last-month':
      return {
        startDate: startOfMonth(subMonths(new Date(), 1)),
        endDate: endOfMonth(subMonths(new Date(), 1)),
      }
  }
}
